/* eslint-disable react/prop-types */
import React, { useId } from "react";

function ToggleSwitchBtn(props) {
  const generatedId = useId();
  const inputId = props.id || generatedId;

  return (
    <div className="form-check form-switch d-flex">
      {props?.labelName && (
        <label className="form-check-label label" htmlFor={inputId}>
          {props.labelName}
        </label>
      )}
      <input
        id={inputId}
        className="form-check-input cursor"
        type="checkbox"
        role="switch"
        checked={!!props.isActive}
        disabled={props.disabled}
        onChange={props.getToggleval}
        required={props.Isrequired}
      />
      {props.Isrequired ? <span className="required ms-2 fs-6">*</span> : null}
    </div>
  );
}

export default ToggleSwitchBtn;
